// El backend espera un día (`YYYY-MM-DD`), no un instante: se arma con los
// campos LOCALES, porque toISOString() corre la fecha al día anterior en
// husos negativos como el nuestro. Un string ISO con hora se recorta al día.
export function toIsoDay(value) {
    if (!value) return null;
    if (typeof value === "string") return value.split("T")[0];
    const mes = String(value.getMonth() + 1).padStart(2, "0");
    const dia = String(value.getDate()).padStart(2, "0");
    return `${value.getFullYear()}-${mes}-${dia}`;
}
